import { useState } from "react";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MenuIcon from "@mui/icons-material/Menu";
import styles from "./Navbar.module.css";
import Button from "../Button/index";
// import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

// const pages = ["Home", "About", "How it works", "Contact us"];

const DrawerComp = ({ handleServicesClick }) => {
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);
  const pages = [
    { label: "Home", target: null },
    { label: "About", target: "about" },
    { label: "How it works", target: "howitworks" },
    { label: "FAQ", target: "faq" },
  ];

  const handleGetStarted = () => {
    const signupUrl = `${process.env.REACT_APP_DOMAIN}/auth/register`

    window.location.href = signupUrl;
  };

  // handle item click and close the drawer
  const handleItemClick = (target, label) => {
    setOpenDrawer(false);
    if (target === "howitworks") {
      navigate("/how-it-works");
    } else if (target) {
      handleServicesClick(target);
    }
  };

  return (
    <>
      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        sx={{
          width: "50%",
          "& .MuiDrawer-paper": {
            width: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            paddingTop: "3px",
            marginTop: "65px",
            paddingLeft: "15px",
          },
        }}
      >
        <List>
          {pages.map((page, index) => (
            <ListItemButton
              key={index}
              onClick={() => handleItemClick(page.target)}
            >
              <ListItemIcon>
                <ListItemText sx={{ color: "white" }}>
                  {page?.label}
                </ListItemText>
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
        <div className={styles.navnewbtn}>
          <Button
            variant="primary"
            color="btnfontprimary"
            buttonSize="buttonfluid"
            buttonName="Get Started"
            onClick={handleGetStarted}
          />
        </div>
      </Drawer>
      <div className={styles.navbtn} onClick={() => setOpenDrawer(!openDrawer)}>
        {openDrawer === false ? (
          <MenuIcon className={`${styles.menuicon}`} sx={{ color: "white" }} />
        ) : (
          <HighlightOffIcon
            className={`${styles.menuicon}`}
            sx={{ color: "white" }}
          />
        )}
      </div>
    </>
  );
};

DrawerComp.propTypes = {
  handleServicesClick: PropTypes.func.isRequired,
};

export default DrawerComp;
